import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ComponentRef, inject, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { PropertyInfoStepComponent } from '../property-info-step/property-info-step.component';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';
import { atLeastOneRequiredValidator } from '../../../shared/utils/atLeastOneRequiredValidator';
import { CommonServices, JurisdictionOption } from '../../../domain/service/commonService';
import { GooglePlacesService } from '../../../domain/service/GooglePlaceService';
import { ExternalUser } from '../../../domain/model/account/externalUser';
import { AuthenticationService } from '../../../security/auth/authentication.service';
import { RentalPropertyOwner } from '../../../domain/model/properties/rentalPropertyOwners';
import { PropertyManagementCompany } from '../../../domain/model/properties/propertyManagementCompany';
import { PropertyService } from '../../../domain/service/propertyService';
import { ReportingFormComponent } from '../reporting-form/reporting-form.component';
import { ManagementCompany } from '../../../domain/model/enrollment/managementCompanies';
import { ManagementCompanyAddComponent } from '../../register/management-company-add/management-company-add.component';
import { Dialog } from '@angular/cdk/dialog';
import { LicenseFormComponent } from '../license-form/license-form.component';
import { InsertPropertyDto, LicenseInfo, RentalProperty, TaxRepresentativeDto } from '../../../domain/model/properties/createProperty/createNewProperty';
import { PropertiesDetailOwnersComponent } from '../properties-detail-owners/properties-detail-owners.component';
import { ConfirmationCancelPropertyComponent } from '../confirmation-cancel-property/confirmation-cancel-property.component';
import { DialogService } from '../../../domain/service/dialog/dialog.service';
import { NotificationType } from '../../../domain/model/enums/notificationType';
import { ComponentPortal } from '@angular/cdk/portal';
import { NotificationComponent } from '../../../shared/notification/notification.component';
import { OverlayRef } from '@angular/cdk/overlay';

const COMPANY_DATA: ManagementCompany[] = [];

@Component({
  selector: 'app-create-new-property',
  templateUrl: './create-new-property.component.html',
  styleUrl: './create-new-property.component.css'
})

export class CreateNewPropertyComponent implements OnInit, AfterViewInit,OnChanges {
  @ViewChild('rentalPropertyReportingFormComponent') rentalPropertyReportingFormComponent: ReportingFormComponent | undefined;
  @ViewChild('rentalPropertyLicenseComponent') rentalPropertyLicenseComponent: LicenseFormComponent | undefined;
  @ViewChild('propertiesDetailOwnersComponent') propertiesDetailOwnersComponent: PropertiesDetailOwnersComponent | undefined;
  @ViewChild('stepper') currentStepper: MatStepper | undefined;
  suggestions: any[] = [];
  dialog = inject(Dialog);
  currentCompany: ManagementCompany | undefined;
  externalUser!:ExternalUser | null;
  owners: RentalPropertyOwner[] = [];
  stepCompleted: boolean = false;
  showTaxRepresentativeForm: boolean = false;
  isReportingTabValid: boolean = false;
  accountType = 1;
  isManager = false;
  isOwner = false;
  showCityLocalRequirements = false;
  isIndividualPropertyOwner = false;
  isMotelHotel = false;
  isManagementCompany = false;
  shouldShowStep = false;
  private overlayRef!: OverlayRef;
  propertySuggestions: PropertyManagementCompany[] = [];
  companyDataSource = new MatTableDataSource(COMPANY_DATA);
  managementcompaniesColumns: string[] = ['name', 'streetAddress', 'aptUnitSuite', 'city', 'state', 'zipCode', 'action'];
  
  constructor( private readonly dialogService: DialogService,private readonly auth: AuthenticationService,private googlePlacesService: GooglePlacesService, private propertyService: PropertyService,private _formBuilder: FormBuilder,private router: Router,private commonServices: CommonServices) {
    this.externalUser = this.auth.getCurrentUser2();

    //this.rentalPropertyReporting
    if (this.externalUser?.accountType == 1){
      this.isIndividualPropertyOwner = true;
      this.rentalProperty.setValidators(atLeastOneRequiredValidator(["usePlatformToRent", "platFormLink"]));
      this.rentalPropertyReporting.get('isUsingTaxRepresentative')?.setValidators(Validators.required);
      
    }
    if (this.externalUser?.accountType == 2){
      this.isManagementCompany = true;
    }
    if (this.externalUser?.accountType == 3){
      this.isMotelHotel = true;
    }
    this.onRentalPropertyBusinessChange();
  } 
  ngOnChanges(changes: SimpleChanges): void {

    this.externalUser = this.auth.getCurrentUser2();
    if (this.externalUser?.accountType == 1){
      this.isIndividualPropertyOwner = true;
      this.rentalProperty.setValidators(atLeastOneRequiredValidator(["usePlatformToRent", "platFormLink"]));

    }
    if (this.externalUser?.accountType == 2){
      this.isManagementCompany = true;
    }
    if (this.externalUser?.accountType == 3){
      this.isMotelHotel = true;
    }
  }
  ngAfterViewInit(): void {
    this.externalUser = this.auth.getCurrentUser2();
    if (this.externalUser?.accountType == 1){
      this.isIndividualPropertyOwner = true;
    }
    if (this.externalUser?.accountType == 2){
      this.isManagementCompany = true;
    
    }
    if (this.externalUser?.accountType == 3){
      this.isMotelHotel = true;
    }
  }
  private onRentalPropertyBusinessChange() {
    this.rentalProperty
      .get("rentalPropertyBusiness")
      ?.valueChanges.subscribe((value) => {
        if (value) {
          this.propertyService.getAutoCompleteProperty(value).subscribe({
            next: (response) => {
              this.propertySuggestions = response;
            },
            error: (error) => {
              this.propertySuggestions = [];
            },
            complete: () => {
              //this.propertySuggestions = [];
            },
          });
        } else {
          this.suggestions = [];
        }
      });
  }

  rentalProperty = new FormGroup({

    propertyStreetAddress: new FormControl('', [Validators.required]),
    aptUnitSuite: new FormControl(''),
    city: new FormControl('', [Validators.required]),
    // Optional on purpose: if an environment has no jurisdictions seeded the list is
    // empty, and a required control would make the property un-submittable.
    jurisdiction: new FormControl(''),
    state: new FormControl({ value: 0, disabled: true }, [Validators.required]),
    zipCode: new FormControl('', [
      Validators.required,
      Validators.maxLength(400),
      Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
    ]),
    startedRenting: new FormControl(null, [Validators.required]),
    // County policy: monthly filing only. Shown, not choosable (QA: adding a property asked again).
    filingFrequency: new FormControl({ value: 'M', disabled: true }),
    businessName: new FormControl(''),
    webUrl: new FormControl('', [Validators.pattern(/^(https?:\/\/|www\.)[a-zA-Z0-9\-\.]+(?:\.[a-zA-Z]{2,})(?:\/[a-zA-Z0-9\-]+)*\/?$/)]),
    usePlatformToRent: new FormControl(false),
    platFormLink: new FormControl('', [Validators.pattern(/^(https?:\/\/|www\.)[a-zA-Z0-9\-\.]+(?:\.[a-zA-Z]{2,})(?:\/[a-zA-Z0-9\-]+)*\/?$/)]),
    rentalPropertyBusiness: new FormControl(''),
  }, { validators: this.externalUser?.accountType == 1? atLeastOneRequiredValidator(['usePlatformToRent', 'platFormLink']): null });
 
 

  rentalPropertyLicense = new FormGroup({
    departmentOfBusiness: new FormControl('', [Validators.pattern(/^[a-zA-Z1-9][a-zA-Z0-9]*$/)]),
    taxCertificateNumber: new FormControl(''),
    stateCertificateHasBeenApplied: new FormControl(null),
    reasonWhy: new FormControl(''),
    certificateOfRegistration: new FormControl(''),
    localBusinessTaxReceipt: new FormControl(''),
    cityOfRegistration: new FormControl(''),
  }, { validators: atLeastOneRequiredValidator(['reasonWhy', 'stateCertificateHasBeenApplied', 'taxCertificateNumber']) });

  rentalPropertyReporting = new FormGroup({

    taxRepresentativeFirstName: new FormControl(),
    taxRepresentativeLastName: new FormControl(),
    taxRepresentativeEmail: new FormControl(),
    taxRepresentativePhoneNumber: new FormControl(),
    taxRepresentativeStreetAddress: new FormControl(),
    taxRepresentativeAptUnitSuite: new FormControl(),
    taxRepresentativeCity: new FormControl(),
    taxRepresentativeState: new FormControl(),
    taxRepresentativeZipCode: new FormControl(),
    sendToOwner: new FormControl(),
    sendToReportingRep: new FormControl(),
    isUsingTaxRepresentative: new FormControl(false),

  });

  ownerForm = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.maxLength(320),
      Validators.email
    ]),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
    ]),
    note: new FormControl(''),
    ownerStreetAddress: new FormControl('',Validators.required),
    aptUnitSuite: new FormControl(''),
    city: new FormControl('',Validators.required),
    state: new FormControl(0,[Validators.required,Validators.min(1)]),
    zipCode:new FormControl('', [
      Validators.required,
      Validators.maxLength(12),
      Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
    ]),
    addressName: new FormControl(''),
    addressOrPoBox: new FormControl(''),
    cityStateProvince: new FormControl(''),
    country: new FormControl(0),
  });
  states: DropDownModel[] = [];
  jurisdictions: JurisdictionOption[] = [];
  countries: DropDownModel[] = [];
  @ViewChild(PropertyInfoStepComponent) propertyInfoStepComponent!: PropertyInfoStepComponent;
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['firstName', 'lastName', 'email', 'phone', 'action'];

  goBack(stepper: MatStepper) {
    stepper.previous();
}
goForward(stepper: MatStepper){
   
  stepper.next();
  
}
showNotification(message: string, title: string, notificationType: NotificationType): void {
  // Create a Portal instance of our `NotificationComponent`
  const notificationPortal = new ComponentPortal(NotificationComponent);
  // Attach our `NotificationComponent` to the Overlay Portal
  const notificationRef: ComponentRef<NotificationComponent> =
    this.overlayRef.attach(notificationPortal);
  // Now we can access the component instance
  // and we can pass input for the `message` prop we created.
  notificationRef.instance.message = message;
  notificationRef.instance.title = title;
  notificationRef.instance.type = notificationType;
  notificationRef.instance.overlayRef = this.overlayRef;
  notificationRef.instance.getColor();

  // Set a timeout to detach our component from the overlay
  // after 3000 milliseconds
  setTimeout(() => {
    this.overlayRef.detach();
  }, 10000);
}
save(){

  // Guard with feedback instead of a silently-disabled submit button: if the
  // license step is incomplete, surface what's missing rather than doing nothing.
  if (this.rentalPropertyLicense.invalid) {
    this.rentalPropertyLicense.markAllAsTouched();
    this.showNotification('Please complete the required license information before submitting.', 'Add property', NotificationType.Error);
    return;
  }

  let property : RentalProperty = {
    id: 0,
    accountID: this.externalUser?.accountId ?? 0,
    status: 'PENDING_APPROVAL',
    rentalPropertyStreetAddress: this.rentalProperty.get('propertyStreetAddress')?.value??'',
    aptUnitSute: this.rentalProperty.get('aptUnitSuite')?.value??'',
    city: this.rentalProperty.get('city')?.value??'',
    stateId: this.rentalProperty.get('state')?.value??0,
    zipCode: this.rentalProperty.get('zipCode')?.value??'',
    startedRenting: this.rentalProperty?.get('startedRenting')?.value??'',
    frequency:this.rentalProperty?.get('filingFrequency')?.value ?? '',
    businessName:this.rentalProperty?.get('businessName')?.value ?? '',
    webUrl: this.rentalProperty?.get('businessName')?.value ?? '',
    useDigitalPlatform: this.rentalProperty?.get('usePlatformToRent')?.value ?? false,
    digitalPlatform:this.rentalProperty.get('platFormLink')?.value ?? '',
    jurisdiction: this.rentalProperty.get('jurisdiction')?.value ?? '',
    appraiserOfficeId: '',
    propertyType: 0,
    isUsingTaxRepresentative: this.rentalPropertyReporting.get('isUsingTaxRepresentative')?.value??false,
    correspondenceToOwner:  this.rentalPropertyReporting.get('sendToOwner')?.value??false,
    correspondenceToReportingRepresentative: this.rentalPropertyReporting.get('sendToReportingRep')?.value??false,
    reportingOwner: this.isOwner,
    reportingPropertyManagementCompany: this.isManagementCompany,
    createdDate: '',
    statusId: 7
  }

  let license : LicenseInfo = {
    id: 0,
    accountId: this.externalUser?.accountId ?? 0,
    regulationLicenseNumber:this.rentalPropertyLicense?.get('departmentOfBusiness')?.value??'',
    certicateOfRegistration: this.rentalPropertyLicense?.get('cityOfRegistration')?.value??'',
    taxCertificateNumber:this.rentalPropertyLicense?.get('taxCertificateNumber')?.value??'',
    stateCertificateHasBeenApplied:  this.rentalPropertyLicense?.get('stateCertificateHasBeenApplied')?.value ??false,
    taxReceipt: this.rentalPropertyLicense?.get('localBusinessTaxReceipt')?.value??'',
    reasonWhy: this.rentalPropertyLicense?.get('reasonWhy')?.value??'',
  }

  let taxRepresentative : TaxRepresentativeDto = {
    id: 0,
    accountId: this.externalUser?.accountId ?? 0,
    firstName:this.rentalPropertyReporting.get('taxRepresentativeFirstName')?.value??'',
    lastName:this.rentalPropertyReporting.get('taxRepresentativeLastName')?.value??'',
    email: this.rentalPropertyReporting.get('taxRepresentativeEmail')?.value??'',
    phoneNumber:this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.value??'',
    streetAddress: this.rentalPropertyReporting.get('taxRepresentativePhoneNumber')?.value??'',
    aptUnitSuite: this.rentalPropertyReporting.get('taxRepresentativeAptUnitSuite')?.value??'',
    city: this.rentalPropertyReporting.get('taxRepresentativeCity')?.value??'',
    state: this.rentalPropertyReporting.get('taxRepresentativeState')?.value??0,
    zipCode: this.rentalPropertyReporting.get('taxRepresentativeZipCode')?.value??'',
  }

 let owners :  RentalPropertyOwner[] = [];

 if (this.externalUser?.accountType ==  1){
  owners = this.propertiesDetailOwnersComponent?.getOwners() ??[]
 }

 if (this.externalUser?.accountType ==  2){
  let owner : RentalPropertyOwner = {
    firstName: this.ownerForm.get("firstName")?.value ?? "",
    lastName: this.ownerForm.get("lastName")?.value ?? "",
    email: this.ownerForm.get("email")?.value ?? "",
    phoneNumber: this.ownerForm.get("phoneNumber")?.value ?? "",
    internalId: "",
    streetAddress: this.ownerForm.get("ownerStreetAddress")?.value ?? "",
    aptUnitSuite: this.ownerForm.get("aptUnitSuite")?.value ?? "",
    city: this.ownerForm.get("city")?.value ?? "",
    zipCode: this.ownerForm.get("zipCode")?.value ?? "",
    internationalAddressName: this.ownerForm.get("addressName")?.value ?? "",
    addressName: this.ownerForm.get('addressName')?.value ?? '',
    internationalPoboxNumber: this.ownerForm.get("addressOrPoBox")?.value ?? "",
    internationalCityStateProvince: this.ownerForm.get("cityStateProvince")?.value ?? "",
    stateId: this.ownerForm.get("state")?.value ?? 0,
    countryId: this.ownerForm.get("country")?.value ?? 0,
    addressType: 1,
    accountPropertyId: 0,
    id: 0,
    accountId: 0,
    streetAddressOrPoBox: '',
    cityStateProvince: ''
  };

  owners.push(owner);
 }

  let model : InsertPropertyDto = {
    rentalProperty: property,
    licenseInfo: license,
    taxRepresentativeDto: taxRepresentative,
    owners: owners
  }

  this.propertyService.createNewRentalProperty(model).subscribe({
    next: (response) => {

    },
    error: (error) => {
      this.showNotification('An error occurred while saving the information. Please try again later.', 'Indiviual property owner', NotificationType.Error);

    },
    complete: () => {
      this.stepCompleted = true;
    }
  });
  
  
}

 
cancelClick() {
  this.dialogService.openCustomDialog(ConfirmationCancelPropertyComponent, () => {
   
  });
}

showAndHideTaxForm(show :boolean){
  this.showTaxRepresentativeForm = show
}
 
 
  ngOnInit(): void {
    
    this.rentalProperty.get('propertyStreetAddress')?.valueChanges.subscribe((value) => {
      if (value) {
        this.googlePlacesService.getPlacesFlorida(value).then((predictions: any) => {
          this.suggestions = predictions;
        });
      } else {
        this.suggestions = [];
      }
    });
    this.commonServices.getAllState(233)
    .subscribe(data => {
      this.states = data.sort((a,b) => a.name.localeCompare(b.name));;
      this.rentalProperty.controls["state"].setValue(1436);
    });
    this.commonServices.getAllCountry()
    .subscribe(data => {
      this.countries = data.sort((a,b) => a.name.localeCompare(b.name));
    });
    this.commonServices.getAllJurisdictions()
    .subscribe(data => {
      this.jurisdictions = data.sort((a, b) => a.name.localeCompare(b.name));
    });
    this.rentalProperty.controls["state"].setValue(1436);
  }

  async selectPlace(place: any) {


    this.suggestions = [];
    const details = await this.googlePlacesService.getPlaceDetails(place.place_id);
    let selectedZipCode = this.googlePlacesService.extractLocationDetails(details);
    if (selectedZipCode.zip) {
      this.rentalProperty.get('zipCode')?.setValue(selectedZipCode.zip);
    }

    if (selectedZipCode.city) {
      this.rentalProperty.get('city')?.setValue(selectedZipCode.city);
    }

    if (selectedZipCode.stateCode) {
      let stateId = this.states.find(e => e.iso2 == selectedZipCode.stateCode)?.id ?? 0;
      this.rentalProperty.get('state')?.setValue(stateId);
    }

    if (selectedZipCode.address) {
      this.rentalProperty.get('propertyStreetAddress')?.setValue(selectedZipCode.address);
      this.rentalProperty.get('propertyStreetAddress')?.updateValueAndValidity();
      this.rentalProperty.get('propertyStreetAddress')?.markAsUntouched();
    }
  }
  async selectProperty(place: any) {
    this.rentalProperty.get("rentalPropertyBusiness")?.setValue(place.name);
  }
  newGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  addCompany() {

    let company: ManagementCompany = {
      companyName: '',
      streetAddress: '',
      aptUnitSuite: '',
      city: '',
      state: 0,
      zipCode: '',
      internalId: this.newGuid(),
      stateName: '',
      id: 0,
      accountId: 0,
      rentalPropertyId: 0
    };

    const dialogRef = this.dialog.open<ManagementCompany>(ManagementCompanyAddComponent, {
      height: '510px',
      disableClose: true,
      data: { company },
    });

    dialogRef.closed.subscribe(result => {
      this.currentCompany = result;
      if (result) {
        COMPANY_DATA.push(result);
        this.companyDataSource = new MatTableDataSource(COMPANY_DATA);
      }
    });
  }
  editCompany(company: ManagementCompany) {
    const dialogRef = this.dialog.open<ManagementCompany>(ManagementCompanyAddComponent, {
      width: '500px',
      height: '510px',
      disableClose: true,
      data: { company },
    });

    dialogRef.closed.subscribe(result => {
      this.currentCompany = result;
      if (result) {
        let index = COMPANY_DATA.findIndex(e => e.internalId == result.internalId);
        COMPANY_DATA[index] = result;
        this.companyDataSource = new MatTableDataSource(COMPANY_DATA);
      }
    });
  }
  removeCompany(index: number) {
    COMPANY_DATA.splice(index, 1);

    this.companyDataSource = new MatTableDataSource(COMPANY_DATA);
  }
}
